module.exports = ".ck-content .media{clear:both;margin:.9em 0;display:block;min-width:15em}"